export type PlanInterval = 'month' | 'year'

const DEFAULT_PLAN_NAME = 'Sen Pro'
const DEFAULT_CURRENCY = 'usd'
const DEFAULT_MONTHLY_PRICE_CENTS = 1400
const DEFAULT_YEARLY_PRICE_CENTS = 14000

function readPriceCents(rawValue: string | undefined, fallback: number): number {
  const parsed = Number(rawValue)

  if (Number.isFinite(parsed) && parsed >= 0) {
    return parsed
  }

  return fallback
}

function formatPriceLabel(priceCents: number, currency: string, interval: PlanInterval): string {
  const formattedAmount = (priceCents / 100).toFixed(priceCents % 100 === 0 ? 0 : 2)
  const symbol = currency === 'usd' ? '$' : currency.toUpperCase()
  return `${symbol}${formattedAmount} / ${interval}`
}

export function getSubscriptionPlanDisplay(interval: PlanInterval = 'month') {
  const name = import.meta.env.VITE_STRIPE_PLAN_NAME || DEFAULT_PLAN_NAME
  const currency = (import.meta.env.VITE_STRIPE_PRICE_CURRENCY || DEFAULT_CURRENCY).toLowerCase()
  const monthlyCents = readPriceCents(
    import.meta.env.VITE_STRIPE_PRICE_MONTHLY_AMOUNT_CENTS ?? import.meta.env.VITE_STRIPE_PRICE_AMOUNT_CENTS,
    DEFAULT_MONTHLY_PRICE_CENTS
  )
  const yearlyCents = readPriceCents(
    import.meta.env.VITE_STRIPE_PRICE_YEARLY_AMOUNT_CENTS,
    DEFAULT_YEARLY_PRICE_CENTS
  )
  const priceCents = interval === 'year' ? yearlyCents : monthlyCents

  return {
    name,
    interval,
    priceCents,
    priceLabel: formatPriceLabel(priceCents, currency, interval),
  }
}

export function getSubscriptionPlanOptions() {
  return {
    monthly: getSubscriptionPlanDisplay('month'),
    yearly: getSubscriptionPlanDisplay('year'),
  }
}
